// BulkEditMembersDialog.js
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useForm } from "react-hook-form";
import ErrorAlert from "../../components/alerts/ErrorAlert";
import { useDispatch } from "react-redux";
import { setDialog } from "../../features/dialog/dialogSlice";
import BulkEditMemberFields from "../members/BulkEditMemberFields";
import { getDateFromDateField } from "../../utils/dataUtils";
// import your mutation hook
import { useBulkEditMembersMutation } from "../../features/members/membersApiSlice";

const dateFields = [
  "birthdate",
  "contractDate",
  "lastTesting",
  "beginningDate",
];

const BulkEditMembersDialog = ({ dialog, handleClose }) => {
  const { data } = dialog;
  const { memberIds } = data;

  const { handleSubmit, control, clearErrors } = useForm();
  const dispatch = useDispatch();
  const [bulkEditMembers, { isError }] = useBulkEditMembersMutation();
  const [errorMessage, setErrorMessage] = useState("");

  const getErrorMessage = (error) => {
    const status = error?.status ?? error?.originalStatus;
    if (status === 401 || status === 403) {
      return "Keine Berechtigung: Mehrfachbearbeitung ist für Ihr Konto nicht erlaubt.";
    }
    return (
      error?.data?.message || "Fehler beim Ändern der Mitglieder"
    );
  };

  const onSubmit = async (formData) => {
    clearErrors();
    const fieldsToUpdate = formData.editItems.map((item) => item.field);
    const updatePayload = {};

    fieldsToUpdate.forEach((field) => {
      const value = formData[field];

      if (value === undefined || value === "") return;

      // Format dates using utility
      if (dateFields.includes(field)) {
        updatePayload[field] = getDateFromDateField(value);
      } else {
        updatePayload[field] = value;
      }
    });

    console.log("memberIds :>> ", memberIds);
    console.log("updatePayload :>> ", updatePayload);

    try {
      setErrorMessage("");
      const result = await bulkEditMembers({
        memberIds,
        updateFields: updatePayload,
      }).unwrap();

      if (result.type === "success") {
        dispatch(
          setDialog({
            title: "Mitglieder erfolgreich geändert!",
            type: "SUCCESS",
            data: { successText: result.message },
          })
        );
      }
    } catch (error) {
      console.error("Bulk update failed", error);
      setErrorMessage(getErrorMessage(error));
    }
  };

  return (
    <Dialog open maxWidth="lg">
      <DialogTitle>{dialog?.title ?? "Mitglieder bearbeiten"}</DialogTitle>
      <DialogContent>
        <form className="form">
          <BulkEditMemberFields control={control} />
        </form>
      </DialogContent>
      {(isError || errorMessage) && (
        <div style={{ marginTop: 15 }}>
          <ErrorAlert
            errorMessage={errorMessage || "Fehler beim Ändern der Mitglieder"}
          />
        </div>
      )}
      <DialogActions>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          onClick={handleSubmit(onSubmit)}
        >
          SPEICHERN
        </Button>
        <Button onClick={handleClose} color="primary">
          Abbrechen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkEditMembersDialog;
